import React from "react";
import Slider from "react-slick";
import { ReferenciaContenido } from "interfaces/ReferenciaContenido";
import TitleSection from "../title-section";

import "./imageGallery.scss"
import "../../organisms/benefits-carousel-mpc/BenefitsCarouselMpc.scss"

const ImageGallery = ({tituloGeneral, listaImagenes, contentful_id} : ReferenciaContenido) => {

    const CarouselProps = {
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1.05,
        arrows: false,
        slidesToScroll: 1,
        waitForAnimate: false,
        autoplay: false,
        fade: false,
    };

    const renderCards = () => listaImagenes.map((imagen, index) => 
        <div className={`m-image-gallery__img-container area${index + 1}`} >
            <img alt={imagen.title} src={imagen.file.url} className="m-image-gallery__img"/>
            <div className="m-image-gallery__text">
                {contentful_id != "1DVNsbKngAIfRdrjSVhfDF" &&
                    <p className="m-image-gallery__title">{imagen.title}</p>
                }
                <p className="m-image-gallery__description">{imagen.description}</p>
            </div>
        </div>
    );

    return (
        <section className="m-image-gallery">
            <TitleSection title={tituloGeneral} type="h2"/>
            <div className="m-image-gallery__container">
            {window.innerWidth <= 760 ? 
                <Slider {...CarouselProps}> 
                    {renderCards()}
                </Slider> 
                :
                <div className="m-image-gallery__grid">
                    {renderCards()}
                </div>
            }
            </div>
        </section>
    );
};

export default ImageGallery;